var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

import { React, Field, merge } from '../dependencies';
export default (function (component, injectProps) {
  return function (props) {
    var p = {};

    if (typeof injectProps === 'function') {
      p = injectProps(props);

      if ((typeof p === 'undefined' ? 'undefined' : _typeof(p)) !== 'object') {
        p = {};
        console.warn('injectProps function has to return an object. It has returned ' + (typeof p === 'undefined' ? 'undefined' : _typeof(p)) + '. Fallbacking to an empty object.');
      }
    } else if ((typeof injectProps === 'undefined' ? 'undefined' : _typeof(injectProps)) === 'object') {
      p = injectProps;
    } else if (typeof injectProps !== 'undefined') {
      console.warn('Type of injectProps is ' + (typeof injectProps === 'undefined' ? 'undefined' : _typeof(injectProps)) + '. Only "function" and "object" are supported. Fallbacking to an empty object.');
    }

    return React.createElement(Field, _extends({
      component: component
    }, merge(p, props)));
  };
});